// removed by extract-text-webpack-plugin
module.exports = {"practiceIcon":"practice-profile-header_practiceIcon--2ilYpJwk","imageCover":"practice-profile-header_imageCover--DXE9Cwm2","foreground":"practice-profile-header_foreground--3NmWx50W","photos":"practice-profile-header_photos--1Gv85dTg"};


//////////////////
// WEBPACK FOOTER
// ./components/profile-header/src/styles/practice-profile-header.scss
// module id = 1072
// module chunks = 0